import PageLayout from '@/components/feature/PageLayout';
import SeoHead from '@/components/feature/SeoHead';
import FaqAccordion from '@/components/base/FaqAccordion';
import SectionHeading from '@/components/base/SectionHeading';
import Hero from './components/Hero';
import HotTicker from './components/HotTicker';
import TodayMain from './components/TodayMain';
import ChartPreview from './components/ChartPreview';
import CaseGrid from './components/CaseGrid';
import ResponsesPreview from './components/ResponsesPreview';
import ChainPreview from './components/ChainPreview';
import CategoryGrid from './components/CategoryGrid';
import BrandStrip from './components/BrandStrip';
import { cases } from '@/mocks/cases';
import { generalFaq, siteMeta } from '@/mocks/site';
import type { CaseItem } from '@/types/content';

const caseList = cases as unknown as CaseItem[];

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '911吃瓜',
    url: siteMeta.domain,
    description: siteMeta.intro,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteMeta.domain}/cases?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '911吃瓜',
    url: siteMeta.domain,
    slogan: siteMeta.slogan,
    email: 'hello@911chigua.example.com',
    description: '911吃瓜是专注娱乐话题梳理的内容站，提供人物关系图、矛盾链条与当事人回应合集。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: generalFaq.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: { '@type': 'Answer', text: item.a },
    })),
  },
];

export default function Home() {
  return (
    <PageLayout>
      <SeoHead
        title="911吃瓜 | 人物关系图 · 当事人回应 · 矛盾链条关系网"
        description="911吃瓜专注娱乐话题梳理，提供清晰的人物关系图、当事人回应合集与矛盾链条时间线，帮你吃透每一个瓜的来龙去脉，看透人物背后的关系网。"
        keywords="911吃瓜,人物关系图,当事人回应,矛盾链条,关系网"
        path="/"
        jsonLd={homeJsonLd}
      />
      <Hero />
      <HotTicker />
      <TodayMain item={caseList[0]} />
      <ChartPreview item={caseList[0]} defaultCenterId="lu-zeyan" />
      <CaseGrid items={caseList} />
      <ResponsesPreview items={caseList} />
      <ChainPreview item={caseList[1]} />
      <CategoryGrid />

      <section className="w-full bg-background-100 border-y border-background-200">
        <div className="w-full px-4 md:px-8 py-14 md:py-20">
          <SectionHeading
            eyebrow="常见问题"
            title="关于 911吃瓜，你可能想问"
            desc="我们把读者最常提出的疑问整理在这里，帮助你更快理解站内的内容组织方式。"
            align="center"
          />
          <div className="mt-8 max-w-3xl mx-auto">
            <FaqAccordion items={generalFaq} />
          </div>
        </div>
      </section>

      <BrandStrip />
    </PageLayout>
  );
}